import { render, staticRenderFns } from "./albaran_cliente.vue?vue&type=template&id=63cd782e&"
import script from "./albaran_cliente.vue?vue&type=script&lang=js&"
export * from "./albaran_cliente.vue?vue&type=script&lang=js&"
import style0 from "./albaran_cliente.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports